import { Inject, Injectable } from '@angular/core';
import {
  AuthHeaders,
  BaseApiService,
  CoreInjectorTokens,
  DocumentDto,
  Environment,
  GetManyDto,
  PageableListV2Dto,
  PriceDto,
  ResponseDto,
  UserDto,
} from '@fleet-beat/core';
import { catchError, map, Observable } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class PricesApiService {
  private readonly baseUrl: string = `${this.environment.apiEndpoint}`;
  private readonly baseAdminUrl: string = `${this.environment.apiEndpoint}/admin`;

  constructor(
    @Inject(CoreInjectorTokens.Environment) private environment: Environment,
    private baseApiService: BaseApiService,
  ) {}

  getManyAsAdmin(params: GetManyDto, auth: AuthHeaders): Observable<PageableListV2Dto<PriceDto>> {
    return this.baseApiService.get(`${this.baseAdminUrl}/prices`, { auth, params }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<PriceDto[]>) => this.baseApiService.mapResponseV2(response)),
      map((response: ResponseDto<PriceDto[]>) => {
        return {
          data: response.data,
          ...response.meta,
        };
      }),
    );
  }

  createOne(data: UserDto, auth: AuthHeaders): Observable<PriceDto> {
    return this.baseApiService.post(`${this.baseAdminUrl}/prices`, data, { auth }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<PriceDto>) => this.baseApiService.mapResponse(response)),
    );
  }

  deleteOne(id: string, auth: AuthHeaders): Observable<PriceDto> {
    return this.baseApiService.delete(`${this.baseAdminUrl}/prices/${id}`, { auth }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<DocumentDto>) => this.baseApiService.mapResponse(response)),
    );
  }

  // NOTE MANAGER

  getMany(params: GetManyDto, auth: AuthHeaders): Observable<PageableListV2Dto<PriceDto>> {
    return this.baseApiService.get(`${this.baseUrl}/prices`, { auth, params }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<PriceDto[]>) => this.baseApiService.mapResponseV2(response)),
      map((response: ResponseDto<PriceDto[]>) => {
        return {
          data: response.data,
          ...response.meta,
        };
      }),
    );
  }

  getOne(id: string, auth: AuthHeaders): Observable<PriceDto> {
    return this.baseApiService.get(`${this.baseUrl}/prices/${id}`, { auth }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<PriceDto>) => this.baseApiService.mapResponse(response)),
    );
  }
}
